import { ConsentType } from '@/enums'

export class Consent {
  constructor(init: Partial<Consent> = {}) {
    this.type = init.type
    this.title = init.title || ''
    this.documentUrl = init.documentUrl || ''
    this.language = init.language || ''
    this.version = init.version
    this.acceptedAt = init.acceptedAt || new Date()
  }

  type?: ConsentType
  title: string
  documentUrl: string
  language: string
  version?: number
  acceptedAt: Date
}
